export default "__VITE_ASSET__e26e1f19__"